// TODO: Вынести глобально
class ControllerSignal {
  private maxSignals: number
  // ссылки на new AbortController() текущего запроса для возможности прерывания.
  signalStack = []

  constructor(maxSignals = 2) {
    this.maxSignals = maxSignals
  }

  createSignal = () => {
    const controller = new AbortController()

    // Если количество активных запросов превышает лимит, то останавливаем их и отправляем новый
    if (this.signalStack.length >= this.maxSignals) this.signalStack[this.signalStack.length - 1].abort()

    // добавляем новый в стек
    this.signalStack.push(controller)

    controller.signal.addEventListener('abort', () => {
      const getIndexStack = this.signalStack.findIndex((i) => i.signal === controller.signal)
      this.signalStack.splice(getIndexStack, 1)
    })

    return controller.signal
  }

  abortSignal = (signal: AbortSignal) => {
    const getIndexStack = this.signalStack.findIndex((i) => i.signal === signal)
    if (getIndexStack > -1) this.signalStack[getIndexStack]?.abort()
  }
  clearSignals = () => {
    this.signalStack.forEach((signal) => signal.abort())
  }
  getSignals = () => {
    return this.signalStack
  }
}

export const ControllerRequestSignalsMap = new ControllerSignal(2)
